import { Suspense, lazy } from 'react'
import { ContentContainer } from 'src/components/contentContainer'

import { ErrorBoundary } from 'src/components/errorBoundary'
import { useDecision } from '@optimizely/react-sdk'
import { LiveHighlightContentProps } from './liveHighlightContent.types'

const LiveHighlight = lazy(
  () => import('src/pages/CommunityDetails/Posts/live/components/liveHighlight/liveHighlight')
)

const LiveHighlightContent = ({
  liveDetail,
  isLoading = false,
  isError = false
}: LiveHighlightContentProps) => {
  const [{ enabled: enableCommunityWebinar }] = useDecision('com_adm_web_enable_community_webinar')

  if (!enableCommunityWebinar || !liveDetail) return null

  return (
    <ErrorBoundary>
      <Suspense fallback={null}>
        <ContentContainer isLoading={isLoading} isError={isError}>
          <LiveHighlight isHighlight liveDetail={liveDetail} />
        </ContentContainer>
      </Suspense>
    </ErrorBoundary>
  )
}

export default LiveHighlightContent
